module.exports = __webpack_public_path__ + "static/media/cxj_logo_bg_red.f503a1ec.png";